import { colors } from "@constants/theme";
import React, { RefObject } from "react";
import { View, TextInput, Pressable, StyleSheet } from "react-native";
import SearchIcon from "@assets/svg/SearchIcon";
import Cross from "@assets/svg/Cross";

interface SearchFieldProps {
  searchPlaceholder: string;
  onSearchInputChange: (text: string) => void;
  searchText: string;
  onPressCrossIcon: () => void;
  textInputRef: RefObject<TextInput>;
  testID?: string;
  setSearchText?: (text: string) => void;
  hideShadow?: boolean;
}

const SearchField: React.FC<SearchFieldProps> = ({
  searchPlaceholder,
  onSearchInputChange,
  searchText,
  onPressCrossIcon,
  textInputRef,
  testID = "",
  setSearchText = () => {},
}) => {
  return (
    <View style={styles.searchBar}>
      <SearchIcon style={styles.searchIcon} />
      <TextInput
        ref={textInputRef}
        testID={testID}
        value={searchText}
        placeholder={searchPlaceholder}
        placeholderTextColor={colors.mediumBlacklightBlack}
        cursorColor={colors.mediumBlacklightBlack}
        returnKeyType="done"
        style={styles.searchInput}
        onChangeText={(text) => {
          setSearchText && setSearchText(text);
          onSearchInputChange(text);
        }}
      />
      {searchText.length > 0 ? (
        <Pressable
          onPress={() => {
            if (textInputRef.current) {
              textInputRef.current.clear();
            }
            onPressCrossIcon();
            setSearchText && setSearchText("");
          }}
          testID="searchIcon"
          style={styles.crossIconContainer}
        >
          <Cross height={15} width={15} />
        </Pressable>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  searchInput: {
    flex: 1,
    fontSize: 14,
    fontWeight: "400",
    height: 44,
  },
  crossIconContainer: {
    padding: 5,
  },
  searchBar: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    borderRadius: 10,
    backgroundColor: colors.white,
    borderWidth: 1,
    borderColor: colors.blank_grey,
    flex: 1,
  },
  searchIcon: {
    marginRight: 8,
  },
});

export default SearchField;
